import { Openapi } from './openapi';
import { PagingDataSource, PagingResponse } from '../pagination';

export class PagingDataSourceImpl<T> implements PagingDataSource<T> {
  api: Openapi;
  operation: string;
  pageSize: number;

  constructor(api: Openapi, operation: string) {
    this.api = api;
    this.operation = operation;
    this.pageSize = 20;
  }

  load(pageNumber: number = 1): Promise<PagingResponse<T>> {
    const parameters = {
      top: this.pageSize,
      skip: (pageNumber - 1) * this.pageSize
    };

    return this.api.request(this.operation, { parameters }).then(resp => ({
      pageStart: resp.data.page_start,
      pageSize: resp.data.page_size,
      totalCount: resp.data.total_count,
      count: resp.data.count,
      data: resp.data.data
    }));
  }
}
